import axios from 'axios'
import { Message } from 'element-ui'
import { getreToken, removeToken } from './auth'
import store from '../store'
import { refreshtoken } from '../services/login'
const service = axios.create({
  // baseURL: process.env.BASE_API,
  timeout: 5000
})

service.interceptors.request.use(
  config => {
    if (localStorage.getItem('Clothes_Token')) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('Clothes_Token')
    }
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 400) {
      if (error.response.data.error_description.indexOf('refresh token') !== -1) {
        removeToken()
        location.replace('/login')
      } else {
        Message({
          message: error.response.data.error_description,
          type: 'error',
          duration: 2 * 1000
        })
      }
    } else if (error.response.status === 401) {
      let reftokendata = {
        grant_type: 'refresh_token',
        refresh_token: getreToken(),
        client_id: 'audiApp',
        client_secret: 'audiApp'
      }
      refreshtoken(reftokendata).then(response => {
        store.dispatch('LoginByrefresh', response).then(() => {
          location.reload()
        }).catch(() => {
        })
      }, (response) => {
        removeToken()
        location.replace('/login') // 否则全部重定向到登录页
      })
    } else if (error.response.status === 404) {
      Message({
        message: '当前数据不存在',
        type: 'error',
        duration: 2 * 1000
      })
    }

    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js